export const parseClinicAddress = (address: string) => {
  const parts = address.split(',').map((part) => part.trim());

  const line1 = parts[0];

  const city = parts[1];

  const stateZip = parts[2]?.split(/\s+/) || [];
  const state = stateZip[0];
  const zip = parts[3] ?? stateZip[1];

  const line2 = null;

  return {
    line1,
    line2,
    city,
    state,
    zip,
  };
};
